import React, { useState } from "react";
import api from "../../api";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setMessage("");
      setMessageType("");

      const response = await api.post("/newsletter/subscribe", {
        email,
      });

      setMessage(response.data?.message || "Inscription réussie.");
      setMessageType("success");
      setEmail("");
    } catch (error) {
      console.error(error);

      setMessage(
        error.response?.data?.errors?.email?.[0] ||
          error.response?.data?.message ||
          "Une erreur est survenue. Veuillez réessayer."
      );

      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="overflow-hidden rounded-3xl border border-white/10 bg-[#0f172a] text-white shadow-sm">
      <div className="grid gap-0 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="p-8 md:p-10">
          <p className="mb-3 inline-flex rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-medium uppercase tracking-[0.2em] text-slate-300">
            Newsletter
          </p>

          <h2 className="mb-4 text-2xl font-semibold leading-tight md:text-3xl">
            Recevez les nouveaux articles et actualités photo
          </h2>

          <p className="max-w-xl text-sm leading-7 text-slate-300 md:text-base">
            Inscrivez-vous pour être informé des nouvelles publications, projets
            photo et mises à jour du site. Pas de spam, uniquement l’essentiel.
          </p>
        </div>

        <div className="border-t border-white/10 bg-white/[0.03] p-8 md:p-10 lg:border-l lg:border-t-0">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="newsletter-email"
                className="mb-2 block text-sm font-medium text-slate-200"
              >
                Adresse email
              </label>

              <input
                id="newsletter-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="exemple@email.com"
                required
                className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-slate-400 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-500/30"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-2xl bg-white px-5 py-3 font-semibold text-slate-900 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {loading ? "Inscription..." : "S’inscrire à la newsletter"}
            </button>

            <p className="text-xs leading-6 text-slate-400">
              Vous pourrez vous désinscrire à tout moment via le lien présent
              dans les emails.
            </p>

            {message && (
              <div
                className={`rounded-2xl px-4 py-3 text-sm ${
                  messageType === "success"
                    ? "border border-green-400/20 bg-green-500/10 text-green-200"
                    : "border border-red-400/20 bg-red-500/10 text-red-200"
                }`}
              >
                {message}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterForm;